import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=db8ef738"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports